import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import args from "./headerArgs";
import ShippingAddress from "./ShippingAddress/ShippingAddress";
import BoxStatus from "./BoxStatus/BoxStatus";
import UpgradeMembership from "./UpgradeMembership/UpgradeMembership";
import ReactivateSubscription from "./ReactivateSubscription/ReactivateSubscription";
import ReferAFriend from "./ReferAFriend/ReferAFriend";
import Box from "./Box/Box";
import SubNav from "./SubNav/SubNav";
import ExpandDetails from "./ExpandDetails/ExpandDetails";
import { boxExpired } from "../../utils/boxStatus";
import FontAwesome from "@bit/fabfitfun.shared.global.font-awesome-collection";

import "./Header.css";

class Header extends Component {
  state = {
    detailsExpanded: false
  };

  toggleExpand = () => {
    this.setState({ detailsExpanded: !this.state.detailsExpanded });
  };

  render() {
    const {
      boxStatusDesc,
      boxStatusTitle,
      boxStatusBillingCTA,
      boxStatusTrackingCTA,
      referCTA,
      referDescription,
      referTitle,
      shippingTitle,
      sysdata,
      reactivateCTA,
      reactivateDescription,
      reactivateTitle,
      upgradeCTA,
      upgradeDescription,
      upgradeTitle,
      skipEligible,
      hasSkipped,
      showGrowthReactivatePopUp,
      rateMyBoxLinkOnMyBoxFlag,
      boxReview,
    } = this.props;

    // TODO Get these links from sysdata configured by Eros
    let subNavLinks = [
      {
        title: "Manage Details",
        url: "/my-account",
        className: ""
      },
      {
        title: "Past Boxes",
        url: "/past-boxes",
        className: ""
      },
      {
        title: "Order History",
        url: "/order-history/",
        className: ""
      },
      {
        title: "Shipping Schedule",
        url: "/upcoming-box-schedule/",
        className: ""
      }
    ];
    if (skipEligible) {
      subNavLinks.push({
        title: "Skip My Box",
        url: "/skip-my-box",
        className: hasSkipped ? "has-skipped" : ""
      });
    }

    const { boxData, isMobile, userData } = sysdata;
    const isSelect = userData ? userData.select : false;
    const isExpired = boxExpired(userData);
    const { currentBox } = boxData || {};
    const { boxStatus } = currentBox || {};
    const isEligible = boxReview && boxReview.eligible;
    const surveyStarted = boxReview && boxReview.surveyStarted;
    const briefBoxStatus =
      boxStatusDesc[boxStatus] || boxStatusDesc["BOX_STATUS_NO_BOX"];

    const rowStyle = cx({
      "flex-fdc": isMobile,
      "flex-aic": isMobile,
      "d-flex": true,
      "w-100": true,
      "flex-jsb": !isMobile,
      "ta-center": isMobile
    });

    const detailStyles = cx({
      "d-flex": true,
      "flex-fdc": isMobile,
      "flex-aic": isMobile,
      "flex-jse": true,
      "o-hidden": true,
      "w-50": !isMobile,
      collapsed: !this.state.detailsExpanded && isMobile,
      expanded: this.state.detailsExpanded && isMobile
    });

    const titleStyles = cx({
      "my-box-page-title": true,
      "mar-0": true,
      "pad-0": true,
      "ff-pds": true,
      "fw-nor": true,
      "ta-center": isMobile
    });

    return (
      <div className="fw-400 ff-ns">
        <h1 className={titleStyles}>My Box</h1>
        <SubNav isMobile={isMobile} links={subNavLinks} />
        <div className="hor-rule" />
        <div className={rowStyle}>
          <Box
            isMobile={isMobile}
            boxData={boxData}
            isEligible={isEligible}
            surveyStarted={surveyStarted}
            rateMyBoxLinkOnMyBoxFlag={rateMyBoxLinkOnMyBoxFlag}
          />

          {/* Move to it's own file */}
          {/* Toggle on Mobile */}
          {isMobile && (
            <ExpandDetails
              expired={isExpired}
              boxStatusDesc={boxStatusDesc}
              expanded={this.state.detailsExpanded}
              onClick={this.toggleExpand}
              boxData={boxData}
            />
          )}

          <div className={detailStyles}>
            {userData && (
              <ShippingAddress title={shippingTitle} userData={userData} />
            )}

            <BoxStatus
              billingCta={boxStatusBillingCTA}
              trackingCta={boxStatusTrackingCTA}
              title={boxStatusTitle}
              boxData={boxData}
              expired={isExpired}
              boxStatusDesc={boxStatusDesc}
            />
          </div>

          {isMobile && <div className="hor-rule mar-h-8" />}

          {!isExpired && !isSelect && (
            <UpgradeMembership
              title={upgradeTitle}
              desc={upgradeDescription}
              cta={upgradeCTA}
            />
          )}

          {isExpired && (
            <ReactivateSubscription
              title={reactivateTitle}
              desc={reactivateDescription}
              cta={reactivateCTA}
              showGrowthReactivatePopUp={showGrowthReactivatePopUp}
            />
          )}
          {!isExpired && isSelect && (
            <ReferAFriend
              title={referTitle}
              desc={referDescription}
              cta={referCTA}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Header;

Header.propTypes = {
  sysdata: PropTypes.shape({}),
  rateMyBoxLinkOnMyBoxFlag: PropTypes.bool,
  boxReview: PropTypes.shape({
    surveyStarted: PropTypes.bool,
    eligible: PropTypes.bool,
  }),
};

Header.defaultProps = {
  sysdata: {
    isMobile: false,
    boxData: {
      season: {},
      currentBox: {},
      boxItems: {},
      boxAddons: {},
      shiplist: []
    }
  },
  boxStatusDesc: {
    EXPIRED: "Looks like you won't be getting this box!",
    NO_BOX: "Your order has not yet been processed",
    PAST_SEASON: "Your Box has arrived!",
    PRE_PROCESSING: "Your order has not yet been processed",
    PROCESSING: "Your order has been saved.",
    ASSIGNED: "Your box is getting ready to ship.",
    DELIVERED: "Your order has been delivered",
    PROBABLY_DELIVERED: "Your order has shipped",
    SHIPPED: "Your order has shipped"
  },
  shippingTitle: "Shipping Address",
  boxStatusTitle: "Box Status",
  boxStatusBillingCTA: "View Billing / Shipping Schedule",
  boxStatusTrackingCTA: "Track Your Order",
  reactivateTitle: "Reactivate your Subscription",
  reactivateDescription:
    "Become an active member today to regain access to add-ons, sales and box customizations.",
  reactivateCTA: "Reactivate Now",
  upgradeTitle: "Want More Perks?",
  upgradeDescription:
    "Upgrade to Select to get earlier shipping, more box customization, early access to sales and more!",
  upgradeCTA: "upgrade now",
  referCTA: "GET $15",
  referTitle: "Refer Friends & Earn Credit",
  referDescription:
    "Refer your friends and get $15 towards your next purchase when they join.",
  rateMyBoxLinkOnMyBoxFlag: false,
  boxReview: {
    surveyStarted: false,
    isEligible: false,
  },
};

Header.args = args;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js